"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SystemTile = require("@ccw-pwa-ui/SystemTile");
var _react = _interopRequireDefault(require("react"));
var _SubNavHeading = require("@ccw-pwa-ui/SubNavHeading");
var _StoreInformationTile = require("@ccw-pwa-ui/StoreInformationTile");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _Button = require("@ccw-pwa-ui/Button");
var _reactBootstrap = require("react-bootstrap");
var _images = _interopRequireWildcard(require("../common_features/assets/images"));
var _helper = require("../common_features/utility/helper");
require("../styles/StoreAlertsDetails.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StoreAlertsDetialsComponent = props => {
  const {
    selectedStore,
    device,
    cAlert,
    navHeadingText,
    SubNavHeadingText,
    SubNavHeadingTitle,
    handleGotoDashboard,
    gotoDashboardtext
  } = props;
  console.log(props, cAlert);
  const getAlertColour = severity => {
    return severity === 2 ? {
      color: '#FA6400'
    } : {
      color: '#0B3471'
    };
  };
  const testStyle = cAlert.severity === 1 ? {
    color: '#E00932'
  } : getAlertColour(cAlert.severity);
  const currentAlertTile = () => {
    var _cAlert$alarmText, _cAlert$alarmText2;
    switch (cAlert === null || cAlert === void 0 ? void 0 : cAlert.type) {
      case 'GENERAL':
        return /*#__PURE__*/_react.default.createElement(_SystemTile.SystemTile, {
          variant: 'alert',
          accessoryName: "General Update",
          alertMessageType: (0, _helper.setAlarmSeveritySign)(cAlert.severity),
          alertText: cAlert === null || cAlert === void 0 ? void 0 : (_cAlert$alarmText = cAlert.alarmText) === null || _cAlert$alarmText === void 0 ? void 0 : _cAlert$alarmText.alertTitle,
          description: {
            content: cAlert === null || cAlert === void 0 ? void 0 : (_cAlert$alarmText2 = cAlert.alarmText) === null || _cAlert$alarmText2 === void 0 ? void 0 : _cAlert$alarmText2.alert_details,
            style: {
              flex: 1,
              height: "10px",
              fontFamily: 'Poppins',
              fontStyle: "normal",
              fontWeight: "600",
              fontSize: "13px",
              lineHeight: "20px",
              color: "#333333",
              left: "50px"
            }
          },
          alertImageLeft: _helper.ALERT_ICONS_MAP[cAlert.severity],
          alertTextStyle: {
            fontSize: 14,
            lingHeight: 15,
            fontWeight: 600,
            ...testStyle
          },
          note: {
            type: "info",
            description: "You have been sent an email regarding this alert.",
            iconLeft: _images.InfoHolo.default,
            iconRight: null,
            style: {
              position: "relative",
              color: "#0B3471",
              fontStyle: "normal",
              fontWeight: "500",
              fontSize: "13px",
              lineHeight: "15px"
            }
          }
        });
      case 'PRODUCT':
      case 'SYSTEM':
        {
          var _cAlert$alarmText3, _cAlert$alarmText4, _cAlert$alarmText5, _cAlert$alarmText6;
          return device !== null && device !== void 0 && device.systemId ? /*#__PURE__*/_react.default.createElement(_SystemTile.SystemTile, {
            variant: 'alert',
            accessoryImageUrl: device.systemImageUrl,
            accessoryImageUrlStyle: {
              marginRight: "40px"
            },
            accessoryName: device.systemModelNumber,
            part: "Part #",
            accessoryPartNumber: device.systemPartNumber,
            installedDateText: "Installed",
            installedDate: (0, _helper.getDate)(cAlert.createdAt),
            alertMessageType: (0, _helper.setAlarmSeveritySign)(cAlert.severity),
            alertText: cAlert === null || cAlert === void 0 ? void 0 : (_cAlert$alarmText3 = cAlert.alarmText) === null || _cAlert$alarmText3 === void 0 ? void 0 : _cAlert$alarmText3.alertTitle,
            description: {
              "content": cAlert === null || cAlert === void 0 ? void 0 : (_cAlert$alarmText4 = cAlert.alarmText) === null || _cAlert$alarmText4 === void 0 ? void 0 : _cAlert$alarmText4.alert_details,
              "style": {
                fontStyle: "normal",
                fontWeight: "600",
                fontSize: "13px",
                lineHeight: "20px"
              }
            },
            alertImageLeft: _helper.ALERT_ICONS_MAP[cAlert.severity],
            alertTextStyle: {
              ...{
                fontSize: 13,
                lingHeight: 20,
                fontWeight: 600
              }
            },
            note: {
              type: "info",
              description: "You have been sent an email regarding this alert.",
              iconLeft: _images.InfoHolo.default,
              iconRight: null,
              style: {
                color: "#0B3471",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "13px",
                lineHeight: "20px"
              }
            }
          }) : /*#__PURE__*/_react.default.createElement(_SystemTile.SystemTile, {
            variant: 'alert',
            accessoryImageUrl: device.gatewayImageUrl,
            accessoryName: "Gateway",
            part: "Part #",
            accessoryPartNumber: device.deviceId,
            installedDateText: "Installed",
            installedDate: (0, _helper.getDate)(cAlert.createdAt),
            alertMessageType: (0, _helper.setAlarmSeveritySign)(cAlert.severity),
            alertText: cAlert === null || cAlert === void 0 ? void 0 : (_cAlert$alarmText5 = cAlert.alarmText) === null || _cAlert$alarmText5 === void 0 ? void 0 : _cAlert$alarmText5.alertTitle,
            description: {
              "content": cAlert === null || cAlert === void 0 ? void 0 : (_cAlert$alarmText6 = cAlert.alarmText) === null || _cAlert$alarmText6 === void 0 ? void 0 : _cAlert$alarmText6.system_details_page,
              "style": {
                fontStyle: "normal",
                fontWeight: "600",
                fontSize: "13px",
                lineHeight: "20px"
              }
            },
            alertImageLeft: _helper.ALERT_ICONS_MAP[cAlert.severity],
            alertTextStyle: {
              fontSize: 13,
              lingHeight: 20,
              fontWeight: 600,
              ...testStyle
            },
            note: {
              type: "info",
              description: "You have been sent an email regarding this alert.",
              iconLeft: _images.InfoHolo.default,
              iconRight: null,
              style: {
                position: "relative !important",
                color: "#0B3471",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "13px",
                lineHeight: "15px",
                paddingRight: "10px",
                paddingTop: "10px"
              }
            }
          });
        }
      default:
        break;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-column",
    style: {
      height: "100vh"
    }
  }, /*#__PURE__*/_react.default.createElement(_SubNavHeading.SubNavHeading, {
    heading: SubNavHeadingText,
    subHeading: SubNavHeadingTitle,
    separator: "|"
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeadingText,
    handleBack: props.handleBack,
    leftArrowImage: _images.default.leftArrow.default
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "storeAlertDetailsTabWidth",
    style: {
      minHeight: "auto",
      maxWidth: "560px",
      alignSelf: "center"
    }
  }, (cAlert === null || cAlert === void 0 ? void 0 : cAlert.type) !== "GENERAL" ? /*#__PURE__*/_react.default.createElement(_StoreInformationTile.StoreInformationTile, {
    name: selectedStore.name,
    address: selectedStore.address,
    arrowImage: _images.default.ArrowRight.default,
    rightButtonShow: false,
    Organization: "Pentair"
  }) : /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-column justify-centent-center align-items-center p-3 alertContainer"
  }, currentAlertTile()), /*#__PURE__*/_react.default.createElement("div", {
    className: "GoToHomeButton"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: gotoDashboardtext,
    onClick: handleGotoDashboard
  }))), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null);
};
var _default = exports.default = StoreAlertsDetialsComponent;